module.exports = __webpack_public_path__ + "media/video_end.4b574ba2.mp4";